import config from './config'

export const authorize = async (
  redirectUrl: string,
  isForceAuth: boolean,
  nonce?: string | undefined,
  customClaim?: string[] | null,
) => {
  if (!nonce) nonce = encodeURIComponent(generateRandomValue())

  let authApiUrl =
    `${config.AUTH_API_BASE_URL()}/as/authorization.oauth2?` +
    `client_id=${encodeURIComponent(config.clientId)}` +
    `&scope=${encodeURIComponent(config.scope)}` +
    `&response_type=${encodeURIComponent(config.responseType)}` +
    `&redirect_uri=${encodeURIComponent(redirectUrl)}&nonce=${nonce}` +
    `${isForceAuth ? '&prompt=login' : ''}`

  if (customClaim) {
    customClaim = customClaim.map(item => `&custom_claim=${item}`)
    authApiUrl += customClaim.join('')
  }

  window.location.replace(authApiUrl)
}

const generateRandomValue = () => {
  const D = new Uint32Array(2)
  window.crypto.getRandomValues(D)
  return D[0].toString(36)
}

export const getURLParameter = <T>(paramName: string, isArrayType = false) => {
  const queryParams = new URLSearchParams(window.location.search)

  return parseQueryParams<T>(queryParams, paramName, isArrayType)
}

const parseQueryParams = <T>(queryParams: URLSearchParams, searchKey: string, isArrayType = false): any => {
  if (!searchKey) return {}
  if (!queryParams.has(searchKey)) return null
  if (isArrayType) {
    const values = queryParams.getAll(searchKey)
    return values as T
  }
  return queryParams.get(searchKey) as T
}
